var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "spacer-top-big", attrs: { "offset-lg": "3", lg: "6" } },
    [
      _c(
        "b-form",
        [
          _c(
            "b-card",
            {
              staticClass: "card-small",
              attrs: { "header-tag": "h3", header: "Job Detail" }
            },
            [
              _c(
                "b-row",
                { staticClass: "pb-3" },
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("JobDetail.type")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Job.type))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "pb-3" },
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("JobDetail.argument")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Job.argument))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "pb-3" },
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("JobDetail.status")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Job.status))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("JobDetail.result")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Job.result))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-right",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _vm.Job.id
                    ? _c(
                        "b-btn",
                        {
                          attrs: {
                            "data-trackname": "jobDetailDelete",
                            variant: "danger"
                          },
                          on: { click: _vm.delete_item }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("JobDetail.delete_btn")) +
                              "\n          "
                          ),
                          _c("i", { staticClass: "fa fa-trash" })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Index/JobDetail.vue?vue&type=template&id=1a5161e6&
// module id = null
// module chunks = 